import {
	type DocsListItem,
	type DocsListRemoteEntry,
	type DocumentListItem,
} from "./document-list.types";

/**
 * Converts a DocsListItem to a DocumentListItem by selecting the most recent data
 */
export const toDocumentListItem = (document: DocsListItem): DocumentListItem => {
	const local = Object.values(document.local)[0] ?? {
		title: "",
		createdAt: new Date(0),
		updatedAt: new Date(0),
		path: "",
	};

	let remote: DocsListRemoteEntry | undefined;
	if (document.remote) {
		remote = Object.values(document.remote)[0];
	}

	// Determine which workspace has a newer updatedAt and use it as the source of truth
	const remoteIsNewer = remote ? remote.updatedAt > local.updatedAt : false;
	const updatedAt = remoteIsNewer && remote ? remote.updatedAt : local.updatedAt;

	return {
		id: document.id,
		title: remoteIsNewer && remote ? remote.title : local.title,
		createdAt: remoteIsNewer && remote ? remote.createdAt : local.createdAt,
		updatedAt,
		path: local.path,
		remote,
	};
};
